/*eslint prefer-rest-params: 0 */
export const ArrayModelServiceModule = angular
    .module('app.services.data.modelService.arrayModelService', [])
    .service('arrayModel', () => {
        var api = {
            assignArrayProperty: assignArrayProperty,
            overrideArrayFunctions: overrideArrayFunctions
        };

        return api;

        function assignParentModel(obj, propName, item) {
            if (!(item instanceof Model)) {
                item = new Model(item);
            }

            Object.defineProperty(item, 'parent', {
                value: obj,
                configurable: true
            });

            Object.defineProperty(item, 'parentName', {
                value: propName,
                configurable: true
            });

            return item;
        }

        function assignArrayProperty(obj, propName) {
            overrideArrayFunctions(obj, propName);
            assignArrayParent(obj, propName);
        }

        function assignArrayParent(obj, propName) {
            if (Array.isArray(obj[propName])) {
                Object.keys(obj[propName]).forEach((el, i) => {
                    if (typeof obj[propName][i] == 'object' && !Array.isArray(obj[propName][i])) {
                        obj[propName][i] = assignParentModel(obj, propName, obj[propName][i]);
                    }
                });
            }
        }

        function overrideArrayFunctions(obj, propName) {
            Object.defineProperty(obj.model[propName], 'push', {
                value() {
                    var args;
                    var newLength;
                    args = arguments;
                    if (args[0] && typeof args[0] === 'object' && !Array.isArray(args[0])) {
                        args[0] = assignParentModel(obj, propName, arguments[0]);
                    }

                    newLength = Array.prototype.push.apply(this, arguments);
                    obj.updateChanges(obj, propName);
                    return newLength;
                },

                configurable: true
            });

            Object.defineProperty(obj.model[propName], 'splice', {
                value() {
                    var args;
                    var newLength;
                    args = arguments;
                    if (args[2] && typeof args[2] === 'object' && !Array.isArray(args[2])) {
                        args[2] = assignParentModel(obj, propName, arguments[2]);
                    }

                    newLength = Array.prototype.splice.apply(this, args);
                    obj.updateChanges(obj, propName);
                    return newLength;
                },

                configurable: true
            });

            Object.defineProperty(obj.model[propName], 'pop', {
                value() {
                    var poppedValue = Array.prototype.pop.apply(this, arguments);
                    obj.updateChanges(obj, propName);
                    return poppedValue;
                },

                configurable: true
            });
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/data/model/arrayModel.service.js